import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraCard, SpecraCardContent, SpecraCardDescription, SpecraCardHeader, SpecraCardTitle, SpecraKeyValueRow } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { fmtCount, fmtPct, fmtUsd } from '../format';
import { countsOnTimePercent } from '../hooks';
function onTimeValue(noPrograms, d) {
    if (noPrograms) return 'No programs yet';
    if (d.isError) return 'Unavailable';
    if (!d.counts) return 'Loading…';
    const pct = countsOnTimePercent(d.counts);
    return pct === null ? 'No approvals yet' : `${pct}% (${d.counts.onTime} of ${d.counts.timingKnown})`;
}
function lateValue(d) {
    if (d.isError) return 'Unavailable';
    if (!d.counts) return 'Loading…';
    return fmtCount(d.counts.stateCounts.late ?? 0);
}
export function RollupCard({ rollup, deliverables }) {
    // A derived percentage has no denominator with zero programs, so 0.0% would
    // read as a failing portfolio rather than an honest "nothing to measure
    // yet." The additive quantities (TCV, funded, risks, issues) stay real zeros.
    const noPrograms = rollup.programCount === 0;
    const pct = (value)=>noPrograms ? '—' : fmtPct(value);
    const metrics = [
        {
            label: 'Funding utilization',
            value: pct(rollup.fundingUtilizationPct)
        },
        {
            label: 'On-time delivery',
            value: onTimeValue(noPrograms, deliverables)
        },
        {
            label: 'Late deliverables',
            value: lateValue(deliverables)
        },
        {
            label: 'Total TCV',
            value: fmtUsd(rollup.totalTcv),
            money: true
        },
        {
            label: 'Funded',
            value: fmtUsd(rollup.totalFunded),
            money: true
        },
        {
            label: 'Open risks',
            value: fmtCount(rollup.openRiskCount)
        },
        {
            label: 'Open issues',
            value: fmtCount(rollup.openIssueCount)
        }
    ];
    return /*#__PURE__*/ _jsxs(SpecraCard, {
        className: "h-full",
        "data-testid": Testids.commandCenter.rollupCard,
        "data-scope-id": rollup.scopeId || 'unassigned',
        children: [
            /*#__PURE__*/ _jsxs(SpecraCardHeader, {
                className: "flex-col items-start gap-0",
                children: [
                    /*#__PURE__*/ _jsx(SpecraCardTitle, {
                        children: rollup.scopeName || 'Unassigned'
                    }),
                    /*#__PURE__*/ _jsxs(SpecraCardDescription, {
                        children: [
                            fmtCount(rollup.programCount),
                            " program",
                            rollup.programCount === 1 ? '' : 's'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraCardContent, {
                className: "py-[var(--space-2)]",
                children: metrics.map((m)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        className: "last:border-b-0",
                        label: m.label,
                        value: m.value,
                        variant: m.money ? 'numeric' : 'default'
                    }, m.label))
            })
        ]
    });
}
